export default __webpack_public_path__ + "static/media/landing-3.149337ac.png";